type Props = {
  message: string;
};

const HtmlMessage: React.FC<Props> = ({ message }: Props) => {
  return <div dangerouslySetInnerHTML={{ __html: message }} />;
};

export default HtmlMessage;
